import { confirmDialog } from 'primereact/confirmdialog'
import { ReactNode } from 'react'
import { commonDialog } from '../context/CommonUIProvider'

interface DefaultOption {
    /** dialog에서 보여줄 메세지 */
    msg: ReactNode
    /** 확인버튼 Callback Function */
    onConfirm?: () => void
    /** 확인버튼명 */
    confirmLabel?: string

    classname?: string
}

interface ExOption extends DefaultOption {
    /** 취소버튼 Callback Function */
    onCancel?: () => void
    /** 취소버튼명 */
    cancelLabel?: string
}

const showCommonDialog = (option: ExOption) => {
    if (option.msg === '') return
    commonDialog({
        className: `common-dialog${
            option.classname ? ' ' + option.classname : ''
        }`,
        children: option.msg,
        onHide: () => {},
        accept: option.onConfirm,
        acceptLabel: option.confirmLabel,
        reject: option.onCancel,
        rejectLabel: option.cancelLabel,
    })
}

export const showAlert = (option: DefaultOption) => {
    showCommonDialog({
        ...option,
        onConfirm: option.onConfirm ?? (() => {}),
    })
}
export const showConfirm = (option: ExOption) => {
    showCommonDialog({
        ...option,
        onConfirm: option.onConfirm ?? (() => {}),
        onCancel: option.onCancel ?? (() => {}),
    })
}
